export const DPD_LOCAL_DOMAIN = "dpdlocal.co.uk";
export const DPD_DOMAIN = "dpd.co.uk";
export const PASSWORD_STRENGTH_SCORE = {
  EMPTY_PASSWORD: -1,
  TOO_SHORT_PASSWORD: 0,
  WEAK_PASSWORD: 1,
  AVERAGE_PASSWORD: 2,
  GOOD_PASSWORD: 3,
  STRONG_PASSWORD: 4
};
export const PASSWORD_STRENGTH_SCORE_LABEL = {
  0: "Too Weak",
  1: "Weak",
  2: "Average",
  3: "Good",
  4: "Strong"
};
export const MIN_PASSWORD_LENGTH = 6;
export const ROLES = {
  myDPD: "myDPD"
};